import Parse from "parse";

import type { Issuecategory } from "./Issuecategory";
import type { Ticket } from "./Ticket";
import type { _User } from "./_User";

type OD3_Tenant = Parse.Object;

export interface Ticket_IssuecategoryAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  issuecategory: Issuecategory;
  tenant?: OD3_Tenant;
  ticket: Ticket;
  user?: _User;
}

export class Ticket_Issuecategory extends Parse.Object<Ticket_IssuecategoryAttributes> {
  static className: string = "OD3_Maintenance_Ticket_Issuecategory";

  constructor(data?: Partial<Ticket_IssuecategoryAttributes>) {
    super("OD3_Maintenance_Ticket_Issuecategory", data as Ticket_IssuecategoryAttributes);
  }

  get issuecategory(): Issuecategory {
    return super.get("issuecategory");
  }
  set issuecategory(value: Issuecategory) {
    super.set("issuecategory", value);
  }
  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
  get ticket(): Ticket {
    return super.get("ticket");
  }
  set ticket(value: Ticket) {
    super.set("ticket", value);
  }
  get user(): _User | undefined {
    return super.get("user");
  }
  set user(value: _User | undefined) {
    super.set("user", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_Ticket_Issuecategory", Ticket_Issuecategory);
